import { Injectable } from '@angular/core';

@Injectable()
export class TpTravelService {
  baseIcon = 'https://co.staticontent.com/flights-images/13.89.0/common/airlines/25x25';
  baseUrl = 'https://media.despegar.com/media/pictures/?tags=airline-';

  constructor() {}

  getSRCIconAirline(carrier: string): string {
    return `${this.baseIcon}/${carrier}.png`;
  }

  getIconAirline(carrier: string) {
    return !!carrier ? `${this.baseUrl}${carrier.toLowerCase()}&size=25x25` : '';
  }
}
